import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import StartPage from "../pages/Start-page";
import VoicePage from "../pages/Voice-page";

const PageContainer = styled.div`
  display: flex;
  direction: row;
  align-items: center;
  justify-content: center;
  min-width: 100vw;
  min-height: 80vh;
  margin-top: 20px;
  padding: 0;
  z-index: 10;
  border: 0px dashed grey;
  ${"" /* border-top: 1px dashed grey;
  border-bottom: 1px dashed grey; */}
`;

const PageHolder = props => {
  const showPage = () => {
    switch (props.pageNr) {
      case 0:
        return <StartPage></StartPage>;
      case 1:
        return <VoicePage></VoicePage>;
      case 2:
        return <h1>props.pageNr</h1>;
      case 3:
        return <h1>{props.pageNr}</h1>;
      default:
        return <h1>PAGE NOT FOUND!</h1>;
    }
  };
  // console.log(props.pageNr);

  return <PageContainer>{showPage()}</PageContainer>;
};

export default PageHolder;
